import { ThemeContext, ThemeEnum, themes } from "../stores/theme/Theme";
import React, { useContext } from "react";

interface IArrowIcon {
    className?: string
}

const ArrowIcon: React.FC<IArrowIcon> = ({className}) => {
    const {theme} = useContext(ThemeContext); 

  return (
    <svg
      viewBox="-19.04 0 75.803 75.803"
      xmlns="http://www.w3.org/2000/svg"
      fill={theme === themes.get(ThemeEnum.DARK) ? "#fff" : "#000"}
      height={16}
      className={className}
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <g
          id="Group_64"
          data-name="Group 64"
          transform="translate(-624.082 -383.588)"
        >
          <path
            id="Path_56"
            data-name="Path 56"
            d="M660.313,383.588a1.5,1.5,0,0,1,1.06,2.561l-33.556,33.56a2.528,2.528,0,0,0,0,3.564l33.556,33.558a1.5,1.5,0,0,1-2.121,2.121L625.7,425.394a5.527,5.527,0,0,1,0-7.807l33.556-33.559A1.5,1.5,0,0,1,660.313,383.588Z"
            fill={theme === themes.get(ThemeEnum.DARK) ? "#fff" : "#000"}
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default ArrowIcon;
